import React, { useEffect, useRef } from 'react'
import shortid from 'shortid'
import useDidUpdate from 'hooks/useDidUpdate'
import navigationController from './navigationController'

type Props = {
  children: React.ReactNode
  position?: string
  id?: any
  cardId?: number
  onClose?: () => void
  maximized?: boolean
}

const Modal: React.FC<Props> = ({
  children,
  ...options
}) => {
  const idRef = useRef()

  const actions = navigationController.useActions()

  useEffect(() => {
    idRef.current = shortid.generate()

    actions.push(  
      children,
      {
        id: idRef.current,
        ...options
      }
    )

    return () => { 
      actions.remove(idRef.current)
    }
  }, [])

  useDidUpdate(() => {
    actions.replace(
      idRef.current,
      children,
      {
        ...options
      }
    )
  }, [children, options])

  return null
}

export default Modal
